import { render, staticRenderFns } from "./Receber.vue?vue&type=template&id=5ceef92a&scoped=true"
import script from "./Receber.vue?vue&type=script&lang=js"
export * from "./Receber.vue?vue&type=script&lang=js"
import style0 from "./Receber.vue?vue&type=style&index=0&id=5ceef92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceef92a",
  null
  
)

export default component.exports